import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import { passwordProblem } from '@jupi/shared'

// A new password twice, checked against the same policy the API applies
// (passwordProblem in @jupi/shared). `onChange` gets the password once it
// is acceptable and both fields match, else null.
export function NewPasswordFields({ email, onChange }: { email?: string | null; onChange: (password: string | null) => void }) {
  const { t } = useTranslation()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [touched, setTouched] = useState(false)

  const problem = password ? passwordProblem(password, email) : null
  const differs = confirm !== '' && confirm !== password

  const update = (next: string, again: string) => {
    onChange(next && !passwordProblem(next, email) && next === again ? next : null)
  }

  return (
    <Stack spacing={2}>
      <TextField
        label={t('auth.newPassword')}
        type="password"
        autoComplete="new-password"
        required
        fullWidth
        value={password}
        onChange={(e) => {
          setPassword(e.target.value)
          update(e.target.value, confirm)
        }}
        onBlur={() => setTouched(true)}
        error={touched && problem !== null}
        helperText={touched && problem ? t(`auth.passwordProblem_${problem}`) : t('auth.passwordRules')}
      />
      <TextField
        label={t('auth.confirmPassword')}
        type="password"
        autoComplete="new-password"
        required
        fullWidth
        value={confirm}
        onChange={(e) => {
          setConfirm(e.target.value)
          update(password, e.target.value)
        }}
        error={differs}
        helperText={differs ? t('auth.passwordsDiffer') : ' '}
      />
    </Stack>
  )
}
